import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function SaveAssetsAnnonationsService(token,data) {
    return axios.post(`${CURRENT_API_URL}/contentmanagement/saveAssetsAnnonations`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        console.log(res.data)
        notify.NotifySuccess("Annotation saved successfully.");
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while saving Annotation, please try again later.");
        return false;
    });
}

export default SaveAssetsAnnonationsService;